import { useRef, useEffect, useState } from "react"
import { Helmet } from 'react-helmet-async'
import LeftContentQuickOrder from "components/QuickOrder/LeftContentQuickOrder"
import RightContentQuickOrder from "components/QuickOrder/RightContentQuickOrder"
// Import interface ProductItem mới (đã đổi tên từ CartItem ở bước trước cho đúng nghĩa)
import { fetchCartProducts, ProductItem } from "../../api/QuickOrder"
import { addItemToCart } from "api/Cart"
import './User/styles.scss'

export default function QuickOrder() {
    // 1. Khai báo State tại cha
    // Lưu ý: Dùng ProductItem[] thay vì CartItem[]
    const [cartItems, setCartItems] = useState<ProductItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const LIMIT = 10;

    // 2. Gọi API khi component cha mount
    useEffect(() => {
        document.body.classList.add("NoneHeaderFooter");

        const loadCartData = async () => {
            setLoading(true);
            try {
                // Gọi API lấy danh sách sản phẩm
                const data = await fetchCartProducts({ page: page, limit: LIMIT, search: searchText || undefined });

                if (data && data.items) {
                    // Cập nhật state với danh sách sản phẩm phẳng
                    setCartItems(data.items);

                    const totalItems = data.total || 0;
                    // Tính tổng số trang (ít nhất là 1 trang)
                    setTotalPage(Math.ceil(totalItems / LIMIT) || 1);
                }
            } catch (error) {
                console.error("Lỗi gọi API:", error);
            } finally {
                setLoading(false);
            }
        };

        loadCartData();

        return () => {
            document.body.classList.remove("NoneHeaderFooter");
        };
    }, [page, searchText]);

    const handleUpdateQuantity = async (productId: number, newQuantity: number) => {
        // FIX: Tìm item dựa trên productId trực tiếp (item.id)
        const currentItem = cartItems.find(item => item.id === productId);
        if (!currentItem) return;

        // FIX: Lấy quantity hiện tại, default 0 nếu chưa có
        const currentQty = currentItem.quantity || 0;
        const delta = newQuantity - currentQty;

        if (delta === 0) return;

        // Cập nhật state Local ngay lập tức để UI mượt mà
        setCartItems(prevItems =>
            prevItems.map(item =>
                item.id === productId // FIX: So sánh trực tiếp id
                    ? { ...item, quantity: newQuantity }
                    : item
            )
        );

        // Gọi API cập nhật giỏ hàng (nếu backend cần delta)
        // Lưu ý: addItemToCart thường dùng để thêm mới hoặc update delta
        // Nếu API của bạn cần set lại số lượng chính xác, hãy kiểm tra lại hàm này
        try {
            await addItemToCart(String(productId), delta);
        } catch (error) {
            console.error("Lỗi update quantity:", error);
            // Có thể rollback state ở đây nếu cần thiết khi lỗi
        }
    };

    return (
        <>
            <Helmet>
                <title>Đặt hàng nhanh - Dược Tâm Hạnh</title>
                <meta name="description" content="Đặt hàng nhanh tại Dược Tâm Hạnh. Tìm và đặt mua dược phẩm nhanh chóng, tiện lợi." />
            </Helmet>
            <div className="MuiContainer-root styles_container__eEOzu MuiContainer-disableGutters MuiContainer-maxWidthLg">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-9 w-full-1199 px-1199-100-140">
                        {/* Breadcrumbs giữ nguyên... */}
                        <div className="styles_containerBreadcrumbs__K4TEO hidden-1199">
                            {/* ... code breadcrumb cũ ... */}
                        </div>

                        {/* 3. Truyền dữ liệu xuống con qua Props */}
                        <LeftContentQuickOrder
                            cartItems={cartItems}
                            loading={loading}
                            onUpdateQuantity={handleUpdateQuantity}
                            page={page}
                            totalPage={totalPage}
                            setPage={setPage}
                            searchText={searchText}
                            onSearchChange={(text: string) => { setSearchText(text); setPage(1); }}
                        />
                    </div>
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 total-quick-order-sidebar">
                        {/* Sidebar giỏ hàng - dùng CartProvider context trực tiếp */}
                        <RightContentQuickOrder />
                    </div>
                </div>
            </div>
        </>
    )
}